import { DropdownChevron } from '@components'
import cn from '@integrations/classnames'
import type { ReactNode } from '@integrations/react'
import { useLayoutEffect, useRef, useState } from '@integrations/react'
import { useDropDownMenu } from 'mmfintech-commons'

import styles from './CustomDropdown.module.scss'

interface Props {
  icon?: ReactNode
  caption?: string
  dropdown?: ReactNode
}

function CustomDropdown({ icon, caption, dropdown }: Props) {
  const { visible, toggleDropDown, setRef } = useDropDownMenu()
  const contentRef = useRef<HTMLDivElement>(null)
  const [dropUp, setDropUp] = useState(false)
  const [alignStart, setAlignStart] = useState(false)

  useLayoutEffect(() => {
    const content = contentRef.current
    const anchor = content?.parentElement
    if (!visible || !content || !anchor) {
      setDropUp(false)
      setAlignStart(false)
      return
    }
    const { top, bottom } = anchor.getBoundingClientRect()
    const menu = content.getBoundingClientRect()
    const menuHeight = menu.bottom - bottom
    const spaceBelow = window.innerHeight - bottom
    setDropUp(menuHeight > spaceBelow && top > spaceBelow)
    setAlignStart(menu.left < 0)
  }, [visible])

  return (
    <div className={cn(styles['custom-dropdown-wrapper'], 'custom-dropdown-wrapper')} ref={setRef}>
      {caption ? (
        <div
          className={cn(styles['dropdown-button'], 'dropdown-button', { [styles['opened']]: visible, opened: visible })}
          onClick={toggleDropDown}
        >
          <div>
            {icon ? <span className={cn(styles['icon'], 'icon')}>{icon}</span> : null}
            <span>{caption}</span>
          </div>
          <DropdownChevron className={cn(styles['chevron'], 'chevron')} expanded={visible} />
        </div>
      ) : icon ? (
        <div className={cn(styles['icon-container'], 'icon-container')} onClick={toggleDropDown}>
          {icon}
        </div>
      ) : null}
      <div
        ref={contentRef}
        className={cn(styles['dropdown-content'], 'dropdown-content', {
          [styles['opened']]: visible,
          opened: visible,
          [styles['alternative']]: !caption,
          alternative: !caption,
          [styles['drop-up']]: dropUp,
          'drop-up': dropUp,
          [styles['align-start']]: alignStart,
          'align-start': alignStart
        })}
      >
        {dropdown}
      </div>
    </div>
  )
}

export default CustomDropdown
